import { useQuery } from "@tanstack/react-query";
import { healthAPI } from "@/lib/api/health";

interface BackendVersion {
  version: string | null;
  loading: boolean;
}

/**
 * Backend version for the login page footer, via the shared health probe.
 * TanStack Query replaces the previous raw fetch-in-effect (StrictMode
 * double-fire, no HTTP status check); `healthAPI.check` already suppresses
 * error toasts, so an unreachable backend just renders no version.
 */
export const useBackendVersion = (): BackendVersion => {
  const query = useQuery({
    queryKey: ["backend-version"],
    queryFn: () => healthAPI.check(),
    staleTime: 60_000,
    retry: false,
  });

  return { version: query.data?.health.version ?? null, loading: query.isLoading };
};
